import ChangePasswordSuccess from './ChangePasswordSuccess'

export default ChangePasswordSuccess
